import React from 'react';
import Navbar from './Navbar';
import Fade from 'react-reveal/Fade';
import backbanner from '../Assets/backbanner.png'
import background from '../Assets/background.png';
import {FiArrowRight} from 'react-icons/fi'

const Home = () => {
  return (
    <div className='home-container'>
        <Navbar/>
        <div className='home-banner-container'>
          <Fade right>
          <div className='home-bannerImage-container'>
              <img src={backbanner} alt="" />
          </div>
          </Fade>
          <div className='home-text-section'>
            <Fade left big>
              <h1 className='primary-heading'>
                  Join The Revolution !
                  {/* BECOME Sustainable. */}
              </h1>
              <p className='primary-text'> 
                  {/* Make it Possible */}
                  Living Sustainably Shouldn't be Expensive.
              </p>
              <button className='secondary-button'>
                Shop Now <FiArrowRight/>
              </button>
            </Fade>
          </div>
            <Fade right>
            <div className='home-image-container'>
              <img className='image' src={background} alt="" />
            </div>
            </Fade>
        </div>
        <Fade bottom duration={1500} >
        <div className='product-work-section-top'>
      <h1 className='primary-heading'>Our Products</h1>
      </div>
        </Fade>
    </div>
  )
}

export default Home
